<template>
  <v-container
    id="detalhe-clientes-sem-faturamento-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1>
        Usuário não tem permissão a essa página não existente
      </h1>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <v-container>
              <v-col
                cols="12"
              >
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                    lg="2"
                  >
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="computedPrimeiroDia"
                          label="Data Inical"
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          readonly
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="primeiroDia"
                        no-title
                        @input="menu = false"
                      />
                    </v-menu>
                  </v-col>
                  <v-col
                    id="menu1"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="2"
                  >
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="computedDateFormatted"
                          label="Data Final"
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="ultimoDia"
                        no-title
                        @input="menu1 = false"
                      />
                    </v-menu>
                  </v-col>
                  <v-col
                    id="selectEmpresa"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                  >
                    <v-select
                      v-model="select"
                      :items="empresa"
                      item-value="id"
                      item-text="nomeExibicao"
                      label="Empresas"
                      multiple
                      return-object
                    />
                  </v-col>
                  <v-col
                    id="selectEmpresa"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                  >
                    <v-select
                      v-model="selectVendedores"
                      :items="vendedor"
                      item-value="id"
                      item-text="vendedor"
                      label="Vendedores"
                      multiple
                      return-object
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.vendedor }}, </span>
                        </v-chip>
                        <v-chip v-if="index === 1">
                          <span>{{ item.vendedor }}, </span>
                        </v-chip>
                        <span
                          v-if="index === 2"
                          class="grey--text text-caption"
                        >
                          (+{{ selectVendedores.length - 2 }} outros)
                        </span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col
                    id="selectEmpresa"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                  >
                    <v-select
                      v-model="selectArea"
                      :items="area"
                      item-value="id"
                      item-text="area"
                      label="Área Comercial"
                      multiple
                      return-object
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.area }}, </span>
                        </v-chip>
                        <v-chip v-if="index === 1">
                          <span>{{ item.area }}, </span>
                        </v-chip>
                        <span
                          v-if="index === 2"
                          class="grey--text text-caption"
                        >
                          (+{{ selectArea.length - 2 }} outros)
                        </span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col
                    id="selectEmpresa"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                  >
                    <v-select
                      v-model="selectRede"
                      :items="rede"
                      item-value="id"
                      item-text="rede"
                      label="Rede"
                      multiple
                      return-object
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.rede }}, </span>
                        </v-chip>
                        <v-chip v-if="index === 1">
                          <span>{{ item.rede }}, </span>
                        </v-chip>
                        <span
                          v-if="index === 2"
                          class="grey--text text-caption"
                        >
                          (+{{ selectRede.length - 2 }} outros)
                        </span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col
                    id="selectEmpresa"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                  >
                    <v-select
                      v-model="selectSupervisor"
                      :items="supervisor"
                      item-value="id"
                      item-text="supervisor"
                      label="Supervisor"
                      multiple
                      return-object
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.supervisor }}, </span>
                        </v-chip>
                        <v-chip v-if="index === 1">
                          <span>{{ item.supervisor }}, </span>
                        </v-chip>
                        <span
                          v-if="index === 2"
                          class="grey--text text-caption"
                        >
                          (+{{ selectSupervisor.length - 2 }} outros)
                        </span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col
                    v-if="receita.length > 0"
                    id="selectEmpresa"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                  >
                    <v-select
                      v-model="selectReceita"
                      :items="receita"
                      item-value="id"
                      item-text="nome"
                      label="Grupo Receita"
                      multiple
                      return-object
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.nome }}, </span>
                        </v-chip>
                        <v-chip v-if="index === 1">
                          <span>{{ item.nome }}, </span>
                        </v-chip>
                        <span
                          v-if="index === 2"
                          class="grey--text text-caption"
                        >
                          (+{{ selectReceita.length - 2 }} outros)
                        </span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col
                    v-if="categoria.length > 0"
                    id="selectEmpresa"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                  >
                    <v-select
                      v-model="selectCategoria"
                      :items="categoria"
                      item-value="idExibicao"
                      item-text="categoria"
                      label="Categoria"
                      multiple
                      return-object
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.categoria }}, </span>
                        </v-chip>
                        <v-chip v-if="index === 1">
                          <span>{{ item.categoria }}, </span>
                        </v-chip>
                        <span
                          v-if="index === 2"
                          class="grey--text text-caption"
                        >
                          (+{{ selectCategoria.length - 2 }} outros)
                        </span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col
                    v-if="promotor.length > 0"
                    id="selectEmpresa"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                  >
                    <v-select
                      v-model="selectPromotor"
                      :items="promotor"
                      item-value="idExibicao"
                      item-text="promotor"
                      label="Promotor"
                      multiple
                      return-object
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.promotor }}, </span>
                        </v-chip>
                        <v-chip v-if="index === 1">
                          <span>{{ item.promotor }}, </span>
                        </v-chip>
                        <span
                          v-if="index === 2"
                          class="grey--text text-caption"
                        >
                          (+{{ selectPromotor.length - 2 }} outros)
                        </span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                    lg="2"
                  >
                    <v-btn
                      id="btnRefazer"
                      class="col-12 lg-12 text-h4"
                      small
                      :color="corPrimaria"
                      dark
                      @click="updateDate()"
                    >
                      <v-icon>
                        mdi-reload-alert
                      </v-icon>
                      Refazer
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-container>
            <v-divider class="mb-5" />
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <v-row id="relatorioMelhoresClientesFaturados">
                        <v-col
                          id="relatorioMelhoresClientesFaturados"
                          cols="9"
                          class="text-left"
                        >
                          Quais são aqueles que mais estão crescendo?
                        </v-col>
                        <v-col
                          cols="1"
                        >
                          <v-btn
                            id="btnPrint"
                            class="col-12 lg-12"
                            small
                            :disabled="enableBtn"
                            :color="corPrimaria"
                            dark
                            @click="imprimir()"
                          >
                            <v-icon>
                              mdi-printer
                            </v-icon>
                            Imprimir
                          </v-btn>
                        </v-col>
                        <v-col
                          cols="1"
                          class="text-right"
                        >
                          <v-tooltip top>
                            <template
                              v-slot:activator="{ on, attrs }"
                            >
                              <v-icon
                                id="iconInformationDevolucaoClientes"
                                class="text-left"
                                v-bind="attrs"
                                v-on="on"
                                @mouseover="enableTexto('324')"
                              >
                                mdi-information-outline
                              </v-icon>
                            </template>
                            <div
                              v-if="codigo === '324'"
                              v-html="textoDetalhesClientesPioresCrescimento"
                            />
                          </v-tooltip>
                        </v-col>
                      </v-row>
                      <div
                        v-if="loading"
                        :style="styleObject"
                        class="text-center"
                      >
                        <v-icon
                          light
                          class="custom-loader"
                          :style="styleObject"
                        >
                          mdi-cached
                        </v-icon>
                        Carregando dados...
                      </div>
                      <div
                        v-else-if="error"
                        class="alert alert-danger"
                      >
                        {{ error }}
                      </div>
                      <div
                        v-else
                      >
                        <v-row
                          id="filtrosPrint"
                          class="hidden"
                        >
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <h3 class="text-center">
                              Filtros Selecionados:
                            </h3>
                            <div class="text-center">
                              Data Inicial: {{ dataInicialImpressao }}
                            </div>
                            <div class="text-center">
                              Data Final: {{ dataFinalImpressao }}
                            </div>
                            <div
                              v-if="select.length > 0"
                              class="'text-center'"
                            >
                              Empresas selecionadas:
                              <ul class="no-list-style">
                                <li
                                  v-for="empresa in select"
                                  :key="empresa"
                                >
                                  {{ empresa.nomeExibicao }}
                                </li>
                              </ul>
                            </div>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <div
                              id="idTable"
                              style="max-width: 100%;"
                            >
                              <table
                                style="width: 100%; overflow-x: auto; color: black; border-collapse: collapse;"
                                class="elevation-1"
                              >
                                <thead>
                                  <tr>
                                    <th
                                      id="dadoMovimentacaoHeader"
                                      style="text-align: center;"
                                      class="black--text title"
                                    >
                                      Cliente
                                    </th>
                                    <th
                                      id="dadoMovimentacaoHeader"
                                      style="text-align: center;"
                                      class="black--text title"
                                    >
                                      Vendedor
                                    </th>
                                    <th
                                      id="dadoMovimentacaoHeader"
                                      style="text-align: center;"
                                      class="black--text title"
                                    >
                                      Rede
                                    </th>
                                    <th
                                      id="dadoMovimentacaoHeader"
                                      style="text-align: center;"
                                      class="black--text title"
                                    >
                                      Fat. Acumu. do Ano Anterior
                                    </th>
                                    <th
                                      id="dadoMovimentacaoHeader"
                                      style="text-align: center;"
                                      class="black--text title"
                                    >
                                      Faturamento Anual Acumulado
                                    </th>
                                    <th
                                      id="dadoMovimentacaoHeader"
                                      style="text-align: center;"
                                      class="black--text title"
                                    >
                                      Variação de Fat. Anual Acumu.
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="item in clientesPioresCrescimento"
                                    :key="item.id"
                                  >
                                    <td
                                      id="dadoMovimentacao"
                                      style="text-align: left;"
                                    >
                                      {{ item.nome_cliente }}
                                    </td>
                                    <td
                                      id="dadoMovimentacao"
                                      style="text-align: left;"
                                    >
                                      {{ item.vendedor }}
                                    </td>
                                    <td
                                      id="dadoMovimentacao"
                                      style="text-align: left;"
                                    >
                                      {{ item.rede }}
                                    </td>
                                    <td
                                      id="dadoMovimentacao"
                                      style="text-align: right;"
                                    >
                                      {{ item.faturamento_anterior }}
                                    </td>
                                    <td
                                      id="dadoMovimentacao"
                                      style="text-align: right;"
                                    >
                                      {{ item.faturamento }}
                                    </td>
                                    <td
                                      id="dadoMovimentacao"
                                      style="text-align: right;"
                                    >
                                      {{ item.variacao }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import Permissao from '../../../../../services/menu'
  import Cliente from '../../../../../services/clientes'

  export default {
    name: 'DashboardDetalhamentoClienteSemFaturamento',
    components: {
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      valorReceber: localStorage.valorReceber,
      valorVencido: 0,
      paginaEnable: false,
      permissaoContasReceber: '',
      primeiroDia: (new Date(localStorage.dataInicial)).toISOString().substr(0, 10),
      ultimoDia: (new Date(localStorage.dataFinal)).toISOString().substr(0, 10),
      empresa: [],
      vendedor: [],
      area: [],
      rede: [],
      supervisor: [],
      select: JSON.parse(localStorage.getItem('empresaId')),
      selectVendedores: JSON.parse(localStorage.getItem('vendedor')),
      selectArea: JSON.parse(localStorage.getItem('area')),
      selectRede: JSON.parse(localStorage.getItem('rede')),
      selectSupervisor: JSON.parse(localStorage.getItem('supervisor')),
      receita: [],
      selectReceita: [],
      categoria: [],
      selectCategoria: [],
      promotor: [],
      selectPromotor: [],
      link: localStorage.linkClientes,
      menu: false,
      menu1: false,
      dataInicialImpressao: false,
      dataFinalImpressao: false,
      codigo: 0,
      orientacao: [],
      textoDetalhesClientesPioresCrescimento: '',
      headersClientesMelhoresPiores: [
        { text: 'Cliente', value: 'nome_cliente', width: '200px', class: 'black--text title' },
        { text: 'Vendedor', value: 'vendedor', width: '210px', class: 'black--text title' },
        { text: 'Rede', value: 'rede', width: '200px', class: 'black--text title' },
        { text: 'Fat. Acumu. do Ano Anterior', value: 'faturamento_anterior', width: '180px', align: 'right', class: 'black--text title' },
        { text: 'Faturamento Anual Acumulado', value: 'faturamento', width: '180px', align: 'right', class: 'black--text title' },
        { text: 'Variação de Fat. Anual Acumu.', value: 'variacao', width: '180px', align: 'right', class: 'black--text title' },
      ],
      clientesPioresCrescimento: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      loading: false,
      error: null,
      enableBtn: true,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.ultimoDia)
      },

      computedPrimeiroDia () {
        return this.formatDatePrimeiroDia(this.primeiroDia)
      },
    },

    mounted () {
      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        this.paginaEnable = true

        this.orientacao = JSON.parse(localStorage.getItem('orientacaoPartipantes'))

        Permissao.showEmpresas(localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            var i = 0

            for (i in resposta.data.empresas) {
              this.empresa.push(resposta.data.empresas[i])
            }

            for (i in resposta.data.vendedores) {
              this.vendedor.push(resposta.data.vendedores[i])
            }

            for (i in resposta.data.area) {
              this.area.push(resposta.data.area[i])
            }

            for (i in resposta.data.rede) {
              this.rede.push(resposta.data.rede[i])
            }

            for (i in resposta.data.supervisor) {
              this.supervisor.push(resposta.data.supervisor[i])
            }

            for (i in resposta.data.receita) {
              this.receita.push(resposta.data.receita[i])
            }

            for (i in resposta.data.categoria) {
              this.categoria.push(resposta.data.categoria[i])
            }

            for (i in resposta.data.promotor) {
              this.promotor.push(resposta.data.promotor[i])
            }
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      formatDate (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePrimeiroDia (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      enableTexto (value) {
        var i = 0

        this.codigo = value

        for (i in this.orientacao) {
          if (this.orientacao[i].codigo === '324') {
            this.textoDetalhesClientesPioresCrescimento = this.orientacao[i].descricao
          }
        }
      },

      updateDate () {
        this.formatarDatasImpressao()

        this.showDadosClientesPioresCrescimento()
      },

      imprimir () {
        var filtros = document.getElementById('filtrosPrint').innerHTML
        var conteudo = document.getElementById('headersClientesPiores').innerHTML

        var telaImpressao = window.open('', '_blank')

        var impressao = filtros + conteudo

        telaImpressao.document.write(impressao)
        telaImpressao.window.print()
        telaImpressao.window.close()
      },

      formatarDatasImpressao () {
        var partesInicial = this.primeiroDia.split('-')
        var ano = partesInicial[0]
        var mes = partesInicial[1]
        var dia = partesInicial[2]
        this.dataInicialImpressao = dia + '/' + mes + '/' + ano

        var partesFinal = this.ultimoDia.split('-')
        var anoFinal = partesFinal[0]
        var mesFinal = partesFinal[1]
        var diaFinal = partesFinal[2]
        this.dataFinalImpressao = diaFinal + '/' + mesFinal + '/' + anoFinal
      },

      showDadosClientesPioresCrescimento () {
        this.loading = true
        this.clientesPioresCrescimento = []
        this.enableBtn = true

        Cliente.showDadosClientesPioresCrescimento(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.selectVendedores, this.selectArea, this.selectRede, this.selectSupervisor, this.selectReceita, this.selectCategoria, this.selectPromotor).then(resposta => {
          if (resposta.data.status) {
            this.enableBtn = false

            this.clientesPioresCrescimento = resposta.data.dadosPioresClientes.map((item) => {
              var listaMelhoresClientes = ({
                nome_cliente: item.nome_cliente,
                vendedor: item.vendedor,
                rede: item.rede,
                faturamento_anterior: item.faturamento_anterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                faturamento: item.faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                variacao: item.variacao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
              })

              return listaMelhoresClientes
            })
          } else if (resposta.data.msg === 'Não há dados para o período selecionado') {
            this.clientesPioresCrescimento = []

            this.error = resposta.data.msg

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false
        })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

  #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px !important;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  @media screen
  and (min-width : 1380px)
  and (max-width : 1600px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }
</style>

<style lang="sass">
  #relatorioMelhoresClientesFaturados
    margin-left: 0.5rem
    font-size: 14px
    font-weight: bold

  #iconInformationMelhoresClientes
    margin-left: 9.5rem
    font-weight: bold

  #headersClientesFaturados
    margin-left: 1.7rem
    margin-right: 1.7rem

  .no-list-style
    list-style-type: none
    padding: 0
    margin: 0

  .no-list-style li
    text-decoration: none

  .hidden
    display: none

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

  #btnPrint
    margin: 0 0 0 5rem

</style>
